"use client";

import { useEffect, useRef } from "react";
import { useUtmTracker } from "@/hooks/use-utm-tracker";

/**
 * 全站 UTM 追踪 + 页面浏览上报组件
 * 放在根布局中，自动捕获 UTM 参数并上报页面访问 + 停留时长
 */
export function UtmTrackerWrapper() {
  useUtmTracker();
  const visitIdRef = useRef<number | null>(null);
  const startTimeRef = useRef<number>(0);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const path = window.location.pathname;
    const referrer = document.referrer;

    // Read UTM params from localStorage
    const utmStr = localStorage.getItem("utm_params");
    let utmData: Record<string, string> = {};
    if (utmStr) {
      try { utmData = JSON.parse(utmStr); } catch { /* ignore */ }
    }

    startTimeRef.current = Date.now();

    // Track page visit
    fetch("/api/track-visit", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        path,
        referrer,
        utmSource: utmData.utm_source,
        utmMedium: utmData.utm_medium,
        utmCampaign: utmData.utm_campaign,
        utmTerm: utmData.utm_term,
        utmContent: utmData.utm_content,
      }),
      keepalive: true,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.visitId) {
          visitIdRef.current = data.visitId;
        }
      })
      .catch(() => {
        /* ignore */
      });

    // Send engagement update when user leaves
    const sendEngagement = () => {
      if (!visitIdRef.current) return;
      const timeOnPage = Math.round((Date.now() - startTimeRef.current) / 1000);
      const isBounce = timeOnPage < 10; // bounce if < 10 seconds

      fetch("/api/track-visit", {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          visitId: visitIdRef.current,
          timeOnPage,
          isBounce,
        }),
        keepalive: true,
      }).catch(() => { /* ignore */ });
    };

    window.addEventListener("beforeunload", sendEngagement);
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        sendEngagement();
      }
    });

    return () => {
      window.removeEventListener("beforeunload", sendEngagement);
    };
  }, []);

  return null;
}
